<div [formGroup]="form" >
  <div [ngSwitch]="field.controlType">

    <div *ngSwitchCase="'textbox'">
      <label [for]="field.key" class="label" [ngClass]="hasFieldError() == true ? 'errorMessage' : null">{{
        field.label
        }}</label> <br>

      <mat-form-field appearance="outline" class="form-field">
        <input matInput
               [id]="field.key"
               [type]="field.type"
               [formControlName]="field.key"
               [ngClass]="hasFieldError() == true ? 'is-invalid' : null">
        <mat-hint *ngIf="!hasFieldError()">
          Please fill in <span class="material-indigo"><b>{{ field.label | titlecase }}</b></span>
        </mat-hint>
        <mat-hint class="errorMessage" *ngIf="hasFieldError()">
          <b>{{ field.label | titlecase }}</b> is required
        </mat-hint>
      </mat-form-field>
    </div>

    <div *ngSwitchCase="'textarea'">
      <label [for]="field.key" class="label" [ngClass]="hasFieldError() == true ? 'errorMessage' : null">{{
        field.label
        }}</label> <br>

      <mat-form-field appearance="outline" class="form-field">
        <textarea matInput
                  [id]="field.key"
                  [type]="field.type"
                  [formControlName]="field.key"
                  [ngClass]="hasFieldError() == true ? 'is-invalid' : null">
        </textarea>
        <mat-hint *ngIf="!hasFieldError()">
          Please fill in <span class="material-indigo"><b>{{ field.label | titlecase }}</b></span>
        </mat-hint>
        <mat-hint class="errorMessage" *ngIf="hasFieldError()">
          <b>{{ field.label | titlecase }}</b> is required
        </mat-hint>
      </mat-form-field>
    </div>

    <div *ngSwitchCase="'dropdown'">
      <label [for]="field.key" class="label" [ngClass]="hasFieldError() == true ? 'errorMessage' : null">{{
        field.label
        }}</label> <br>

      <mat-form-field appearance="outline" class="form-field">
        <mat-select [id]="field.key"
                    [formControlName]="field.key"
                    [ngClass]="hasFieldError() == true ? 'is-invalid' : null">
          <mat-option value="all">All {{field.label}}</mat-option>
          <mat-option *ngFor="let opt of field.options" [value]="convertNumber(opt.key)">
            {{ opt.value | titlecase }}
          </mat-option>
        </mat-select>
        <mat-hint *ngIf="!hasFieldError()">
          Please Select <span class="material-indigo"><b>{{ field.label | titlecase }}</b></span>
        </mat-hint>
        <mat-hint class="errorMessage" *ngIf="hasFieldError()">
          <b>{{ field.label | titlecase }}</b> is required
        </mat-hint>
      </mat-form-field>
    </div>

    <div *ngSwitchCase="'dropdown-select'">
      <label [for]="field.key" class="label" [ngClass]="hasFieldError() == true ? 'errorMessage' : null">{{
        field.label
        }}</label> <br>

      <mat-form-field appearance="outline" class="form-field">
        <mat-select [id]="field.key"
                    [formControlName]="field.key"
                    [ngClass]="hasFieldError() == true ? 'is-invalid' : null" multiple>

          <mat-option value="All" (click)="selectAll(field.key)">All {{field.label}}</mat-option>

          <mat-select-trigger>
            {{form.get(field.key).value?.[0] || ''}}
            <span *ngIf="(form.get(field.key).value?.length || 0) > 1" class="example-additional-selection">
            (+{{(form.get(field.key).value?.length || 0) - 1}} {{form.get(field.key).value?.length === 2 ? 'other' : 'others'}})
          </span>
          </mat-select-trigger>

          <mat-option *ngFor="let opt of field.options" [value]="convertNumber(opt.key)">
            {{ opt.value | titlecase }}
          </mat-option>

        </mat-select>
        <mat-hint *ngIf="!hasFieldError()">
          Please Select <span class="material-indigo"><b>{{ field.label | titlecase }}</b></span>
        </mat-hint>
        <mat-hint class="errorMessage" *ngIf="hasFieldError()">
          <b>{{ field.label | titlecase }}</b> is required
        </mat-hint>
      </mat-form-field>
    </div>


    <div *ngSwitchCase="'datepicker'">
      <label [for]="field.key" class="label" [ngClass]="hasFieldError() == true ? 'errorMessage' : null">{{
        field.label
        }}</label> <br>

      <mat-form-field appearance="outline" class="form-field">
        <input matInput [matDatepicker]="picker"
               [id]="field.key"
               [formControlName]="field.key"
               [ngClass]="hasFieldError() == true ? 'is-invalid' : null">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-hint *ngIf="!hasFieldError()">
          Please Select <span class="material-indigo"><b>{{ field.label | titlecase }}</b></span>
        </mat-hint>
        <mat-hint class="errorMessage" *ngIf="hasFieldError()">
          <b>{{ field.label | titlecase }}</b> is required
        </mat-hint>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

<!--    <div *ngSwitchCase="'daterange'">-->
<!--      <label class="label">{{-->
<!--        field.label-->
<!--        }}</label> <br>-->

<!--      <mat-form-field appearance="outline" class="form-field pb-0">-->
<!--        <mat-date-range-input [rangePicker]="picker">-->
<!--          <input matStartDate placeholder="Start date" [value]="selectedDateRange ? selectedDateRange.start : ''"  (dateChange)="dateChange('start', $event)">-->
<!--          <input matEndDate placeholder="End date" [value]="selectedDateRange ? selectedDateRange.end : ''" (dateChange)="dateChange('end', $event)">-->
<!--        </mat-date-range-input>-->
<!--        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>-->
<!--        <mat-date-range-picker #picker></mat-date-range-picker>-->
<!--      </mat-form-field>-->

<!--      <div class="btn-group pt-0">-->
<!--        <button type="button" class="btn" [ngClass]="{ 'active': selectedDateRangeButton === 'today' }" (click)="onButtonDateRangeChange('today')">Today</button>-->
<!--        <button type="button" class="btn" [ngClass]="{ 'active': selectedDateRangeButton === 'thisWeek' }" (click)="onButtonDateRangeChange('thisWeek')">This Week</button>-->
<!--        <button type="button" class="btn" [ngClass]="{ 'active': selectedDateRangeButton === 'thisMonth' }" (click)="onButtonDateRangeChange('thisMonth')">This Month</button>-->
<!--        <button type="button" class="btn" [ngClass]="{ 'active': selectedDateRangeButton === 'lastMonth' }" (click)="onButtonDateRangeChange('lastMonth')">Last Month</button>-->
<!--        <button type="button" class="btn" [ngClass]="{ 'active': selectedDateRangeButton === 'thisYear' }" (click)="onButtonDateRangeChange('thisYear')">This Year</button>-->
<!--        <button type="button" class="btn" [ngClass]="{ 'active': selectedDateRangeButton === 'custom' }" (click)="onButtonDateRangeChange('custom')">Custom</button>-->
<!--      </div>-->
<!--    </div>-->

    <div *ngSwitchCase="'daterange'">
      <label class="label">{{
          field.label
        }}</label> <br>

      <mat-form-field appearance="outline" class="mr-3">
        <input matInput [ngxMatDatetimePicker]="pickerStart" placeholder="Choose a date"
               [disabled]="false"
               [(ngModel)]="selectedDateRange.start" (ngModelChange)="dateChange('start', $event)" [ngModelOptions]="{standalone: true}">
        <ngx-mat-datepicker-toggle matSuffix [for]="pickerStart"></ngx-mat-datepicker-toggle>
        <ngx-mat-datetime-picker #pickerStart [showSpinners]="true" [showSeconds]="false"
                                 [stepHour]="1" [stepMinute]="1" [stepSecond]="1" [touchUi]="false"
                                 [color]="'warn'" [enableMeridian]="true" [disableMinute]="false" [hideTime]="false">
          <ngx-mat-datepicker-actions>
            <button mat-button ngxMatDatepickerCancel>Cancel</button>
            <button mat-raised-button color="primary" ngxMatDatepickerApply>Apply</button>
          </ngx-mat-datepicker-actions>
        </ngx-mat-datetime-picker>

        <mat-hint *ngIf="!hasFieldError()">
          Please Select <span class="material-indigo"><b>Date Start</b></span>
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="mr-3">
        <input matInput [ngxMatDatetimePicker]="pickerEnd" placeholder="Choose a date"
               [disabled]="false"
               [(ngModel)]="selectedDateRange.end" (ngModelChange)="dateChange('end', $event)" [ngModelOptions]="{standalone: true}">
        <ngx-mat-datepicker-toggle matSuffix [for]="pickerEnd"></ngx-mat-datepicker-toggle>
        <ngx-mat-datetime-picker #pickerEnd [showSpinners]="true" [showSeconds]="false"
                                 [stepHour]="1" [stepMinute]="1" [stepSecond]="1" [touchUi]="false"
                                 [color]="'warn'" [enableMeridian]="true" [disableMinute]="false" [hideTime]="false">
          <ngx-mat-datepicker-actions>
            <button mat-button ngxMatDatepickerCancel>Cancel</button>
            <button mat-raised-button color="primary" ngxMatDatepickerApply>Apply</button>
          </ngx-mat-datepicker-actions>
        </ngx-mat-datetime-picker>
        <mat-hint *ngIf="!hasFieldError()">
          Please Select <span class="material-indigo"><b>Date End</b></span>
        </mat-hint>
      </mat-form-field>

      <br>
      <div class="btn-group pt-0">
        <button type="button" class="btn" [ngClass]="{ 'active': selectedDateRangeButton === 'today' }" (click)="onButtonDateRangeChange('today')">Today</button>
        <button type="button" class="btn" [ngClass]="{ 'active': selectedDateRangeButton === 'thisWeek' }" (click)="onButtonDateRangeChange('thisWeek')">This Week</button>
        <button type="button" class="btn" [ngClass]="{ 'active': selectedDateRangeButton === 'thisMonth' }" (click)="onButtonDateRangeChange('thisMonth')">This Month</button>
        <button type="button" class="btn" [ngClass]="{ 'active': selectedDateRangeButton === 'lastMonth' }" (click)="onButtonDateRangeChange('lastMonth')">Last Month</button>
        <button type="button" class="btn" [ngClass]="{ 'active': selectedDateRangeButton === 'thisYear' }" (click)="onButtonDateRangeChange('thisYear')">This Year</button>
        <button type="button" class="btn" [ngClass]="{ 'active': selectedDateRangeButton === 'custom' }" (click)="onButtonDateRangeChange('custom')">Custom</button>
      </div>
    </div>

    <div *ngSwitchCase="'autocomplete'">
      <label [for]="field.key" class="label" [ngClass]="hasFieldError() == true ? 'errorMessage' : null">{{
        field.label
        }}</label> <br>

      <mat-form-field appearance="outline" class="form-field">
        <input
          type="text"
          aria-label="Number"
          matInput
          [matAutocomplete]="autoComplete"
          #searchConsumerInput
          (input)="searchAutocomplete($event)"
          [id]="field.key"
          [formControlName]="field.key"
          [ngClass]="hasFieldError() == true ? 'is-invalid' : null"
        />
        <nb-icon matSuffix icon="search-outline" class="mr-2 text-muted"></nb-icon>
        <i *ngIf="loadingAutocomplete" matSuffix class="fas fa-spinner fa-spin fa-2x fa-fw"></i>

        <mat-autocomplete #autoComplete="matAutocomplete">
          <mat-option
            *ngFor="let data of autocompleteList"
            [value]="data.key"
            (onSelectionChange)="changeAutocomplete(data, field.key, $event)">
            <div class="mb-2">
              <span style="font-weight: 400">{{ data.value }}</span> <br>
              <span *ngFor="let ref of data.ref; let last = last;" class="text-muted small">
                {{ref.key}} :  {{ref.value}}
                <span *ngIf="!last">|</span>
              </span>
            </div>
          </mat-option>
        </mat-autocomplete>
        <mat-hint *ngIf="!hasFieldError()">
          Please Select <span class="material-indigo"><b>{{ field.label | titlecase }}</b></span>
        </mat-hint>
        <mat-hint class="errorMessage" *ngIf="hasFieldError()">
          <b>{{ field.label | titlecase }}</b> is required
        </mat-hint>
      </mat-form-field>
    </div>

    <div class="form-check" *ngSwitchCase="'checkbox'">
      <label [for]="field.key" class="label" [ngClass]="hasFieldError() == true ? 'errorMessage' : null">{{
        field.label
        }}</label> <br>
      <mat-checkbox class="example-margin"
                    [id]="field.key"
                    [formControlName]="field.key"
                    [ngClass]="hasFieldError() == true ? 'is-invalid' : null">
        {{ field.label | titlecase }}
        <mat-hint *ngIf="!hasFieldError()">
          <small>Please Select <span class="material-indigo"><b>{{ field.label | titlecase }}</b></span></small>
        </mat-hint>
        <mat-hint class="errorMessage" *ngIf="hasFieldError()">
          <small><b>{{ field.label | titlecase }}</b> is required</small>
        </mat-hint>
      </mat-checkbox>
    </div>

    <div *ngSwitchCase="'radio'">
      <label [for]="field.key" class="label" [ngClass]="hasFieldError() == true ? 'errorMessage' : null">{{
        field.label
        }}</label> <br>
      <mat-radio-group
        aria-labelledby="example-radio-group-label"
        class="example-radio-group"
        [id]="field.key"
        [formControlName]="field.key"
        [ngClass]="hasFieldError() == true ? 'is-invalid' : null">
        <mat-radio-button class="example-radio-button"  *ngFor="let opt of field.options"
                          [value]="convertNumber(opt.key)"
                          [checked]="convertNumber(opt.key) && convertNumber(opt.key) == convertNumber(field.value)? true : false">
          {{ opt.value | titlecase }}
        </mat-radio-button>
        <mat-hint *ngIf="!hasFieldError()">
          <small>Please Select <span class="material-indigo"><b>{{ field.label | titlecase }}</b></span> </small>
        </mat-hint>
        <mat-hint class="errorMessage" *ngIf="hasFieldError()">
          <small> <b>{{ field.label | titlecase }}</b> is required</small>
        </mat-hint>
      </mat-radio-group>
    </div>

    <div *ngSwitchCase="'newline'">
      <hr class="form-seperator" />
    </div>

    <div *ngSwitchCase="'header'">
     <p class="header">{{field.label}}</p>
    </div>
    <div *ngSwitchCase="'space'">
      <div></div>
    </div>
  </div>
</div>
